/* ATARA motion: hero word reveal, scroll reveals, cart badge bump */
(function () {
  'use strict';
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function splitHero(scope) {
    $$('.hero .hero__copy .h-xl', scope).forEach(function (h) {
      if (h.classList.contains('is-split')) return;
      var words = h.textContent.trim().split(/\s+/);
      if (!words.length || !words[0]) return;
      h.setAttribute('aria-label', h.textContent.trim());
      h.textContent = '';
      words.forEach(function (w, i) {
        var outer = document.createElement('span'); outer.className = 'w'; outer.setAttribute('aria-hidden', 'true');
        var inner = document.createElement('span'); inner.textContent = w; inner.style.setProperty('--i', i);
        outer.appendChild(inner); h.appendChild(outer);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
      h.parentNode.style.setProperty('--words', words.length);
      h.classList.add('is-split');
    });
  }

  var groups = [
    ['.sec-title', ''],
    ['.p-grid > *', 'stagger'],
    ['.set-list > *', 'stagger'],
    ['.builder__list > .b-item', 'stagger'],
    ['.builder__sum', ''],
    ['.expo .media, .story .media, .it .media, .ritual__media', 'img'],
    ['.expo__text, .story__quote, .story__sig, .it__copy, .rich', ''],
    ['.finder__qs, .finder__answer', ''],
    ['.club__nums > *', 'stagger'],
    ['.ritual__steps li', 'stagger'],
    ['.footer-grid > *', 'stagger']
  ];

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function initReveal(scope) {
    if (!io) return;
    var vh = window.innerHeight || 800;
    groups.forEach(function (g) {
      $$(g[0], scope).forEach(function (el) {
        if (el.classList.contains('rv') || el.closest('.hero, #CartDrawer, #MenuDrawer')) return;
        if (el.getBoundingClientRect().top < vh * 0.92) return;
        el.classList.add('rv');
        if (g[1] === 'img') el.classList.add('rv--img');
        if (g[1] === 'stagger') {
          var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
          el.style.setProperty('--rv-delay', ((idx % 4) * 0.09) + 's');
        }
        io.observe(el);
        pending.push(el);
      });
    });
  }

  var pending = [], timer = null;
  function check() {
    var vh = window.innerHeight || 800;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      if (el.getBoundingClientRect().top < vh * 0.94) { el.classList.add('is-in'); io.unobserve(el); return false; }
      return true;
    });
  }
  window.addEventListener('scroll', function () {
    if (timer || !pending.length) return;
    timer = setTimeout(function () { timer = null; check(); }, 120);
  }, { passive: true });

  function watchBadge() {
    $$('[data-cart-count]').forEach(function (b) {
      if (b._mo) return;
      b._mo = new MutationObserver(function () {
        b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
      });
      b._mo.observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  splitHero(document);
  document.addEventListener('DOMContentLoaded', function () { splitHero(document); initReveal(document); watchBadge(); });
  document.addEventListener('shopify:section:load', function (e) { splitHero(e.target); initReveal(e.target); });
})();